// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Confirm__buttons___Pl4yQ","ok":"Confirm__ok___3wUwZ"};